import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
  Divider,
} from '@mui/material';
import { useAppSelector } from '../../store/hooks';

interface ViewNodeModalProps {
  open: boolean;
  onClose: () => void;
}

const ViewNodeModal: React.FC<ViewNodeModalProps> = ({ open, onClose }) => {
  const { selectedNode, loading } = useAppSelector((state) => state.nodes);

  if (!selectedNode && !loading) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Ver Nodo</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
            <CircularProgress />
          </Box>
        ) : selectedNode ? (
          <Box sx={{ mt: 2 }}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                ID
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedNode.id}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Código
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedNode.code}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Nombre
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedNode.name}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Palabras Clave
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedNode.keywords?.join(', ') || ''}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Peso Semántico
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedNode.semanticWeight}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Orden
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedNode.order}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Creado el
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedNode.createdAt}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Creado por
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedNode.createdBy || ''}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Actualizado el
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedNode.updatedAt}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Actualizado por
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedNode.updatedBy || ''}
              </Typography>
            </Box>
          </Box>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewNodeModal;
